// @ts-nocheck
class SwiperSlider extends HTMLElement {
    constructor () {
      super();
      try {
        this.swiperContainer = this.querySelector('swiper-container');
        this.shouldSetSlideHeight = this.getAttribute('data-set-slide-height') === 'true' ? true : false;
        
        if (!this.swiperContainer) {
          console.error('[SwiperSlider] Error: Could not find swiper-container element');
          return;
        }
        
        try {
          this.swiperParams = this.getAttribute('data-swiperParams') ? JSON.parse(this.getAttribute('data-swiperParams')) : {};
          
        } catch (error) {
          console.error('[SwiperSlider] Error parsing swiper parameters:', error.message, this.swiperContainer);
          this.swiperParams = {};
        }
      } catch (error) {
        console.error('[SwiperSlider] Error in constructor:', error.message);
      }
    }

    connectedCallback () {
      try {
        this.initSwiper();
      } catch (error) {
        console.error('[SwiperSlider] Error in connectedCallback:', error.message);
      }
    }

    initSwiper () {
      try {
        if (!this.swiperContainer) {
          console.error('[SwiperSlider] Cannot initialize: swiper-container not found');
          return;
        }

          // Create the 'on' property if it doesn't exist
          if (!this.swiperParams.on) {
            this.swiperParams.on = {};
          }
          
          // Add init and resize event handlers
          this.swiperParams.on.init = () => {
            setTimeout(() => {
              this.init(this.swiperContainer.swiper);
            }, 0);
          };
          
          this.swiperParams.on.resize = () => {
            this.resize(this.swiperContainer.swiper);
          };
        
        // now we need to assign all parameters to Swiper element
        Object.assign(this.swiperContainer, this.swiperParams);
        
        
        // and now initialize it
        this.swiperContainer.initialize();
      } catch (error) {
        console.error('[SwiperSlider] Error initializing swiper:', error.message);
      }
    }
  
    init(swiper) {
      try {
        // Add event handlers to swiperParams if we need to set slide height
        if (this.shouldSetSlideHeight) {
          this.setSlideHeight(swiper);
        }
      } catch (error) {
        console.error('[SwiperSlider] Error in init:', error.message);  
      }
    }
  
    resize(swiper) {
      try {
        // Add event handlers to swiperParams if we need to set slide height
        if (this.shouldSetSlideHeight) {
          this.setSlideHeight(swiper);
        }
      } catch (error) {
        console.error('[SwiperSlider] Error in resize:', error.message);  
      }
    }
  
    setSlideHeight(swiper) {
      try {
        const slides = swiper.slides;
        const height = slides.map(item => item.querySelector('.expert-card').offsetHeight).sort((a, b) => b - a).slice(0, 3).reduce((sum, value) => sum + value, 0);
        const actualHeight = (height / 2) + 50;
        document.querySelector('.expert-say-swiper-container').style.height = actualHeight + 'px';
      } catch (error) {
        console.error('[SwiperSlider] Error setting slide height:', error.message);
      }
    };
    
  }

  if (!customElements.get('swiper-slider')) {
    customElements.define('swiper-slider', SwiperSlider);
  }
